<script setup lang="ts">
import GradeLevelTagLabel from "~components/GradeLevelTagLabel.vue"
import {StudentRow} from "~components/teacher/assign/assignment"

withDefaults(
  defineProps<{
    student: StudentRow
    showGradeLevel?: boolean
    size?: "xs" | "sm" | "md"
  }>(),
  {
    showGradeLevel: false,
    size: "md",
  },
)

defineEmits(["click"])
</script>

<template>
  <div class="student-tag" :class="`size-${size}`" @click="$emit('click')">
    <span class="student-name">{{ student.name }}</span>

    <GradeLevelTagLabel v-if="showGradeLevel && student.level" :grade="student.level" :size="size ?? 'md'" />
  </div>
</template>

<style lang="scss" scoped>
.student-tag {
  display: inline-flex;
  gap: 3px;
  align-items: center;
  white-space: nowrap;

  background-color: #eee;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 0.1rem;
  margin: 0.25rem;

  &.size-xs {
    font-size: 0.66rem;
  }

  &.size-sm {
    font-size: 0.8rem;
  }

  &.size-md {
    font-size: 1rem;
  }
}
</style>
